module.exports = __webpack_public_path__ + "static/media/galdisa_blogImg23.5de7f78d.jpg";